function newsletterModal(isShow, timer) {
  if (!isShow) {
    return;
  }

  let modal;

  document.addEventListener('click', (e) => {
    // Open the modal when clicked on the below class element
    if (e.target.className === 'modal-open') {
      modal = document.getElementById(e.target.dataset.id);
      openModal(modal);
    }
    // Close the modal when clicked on the below class element - Close the modal when clicked out the modal
    else if (e.target.className === 'aw-newsletter-modal-close') {
      // Find the modal by traversing up from the close button
      const modalToClose = e.target.closest('.aw-newsletter-modal');
      if (modalToClose) {
        closeModal(modalToClose, false);
      }
    } else if (e.target == modal) {
      if (modal) {
        closeModal(modal, false);
      }
    } else if (e.target.id == 'mc-embedded-subscribe') {
      setTimeout(() => {
        const message = document.getElementById("mce-success-response");
        if (message && message.textContent.trim() === "Thank you for subscribing!") {
          const modalToClose = document.getElementById('aw-newsletter-modal');
          if (modalToClose) {
            closeModal(modalToClose, true);
          }
          console.log("Matched exactly");
        } else {
          console.log("already subscribed or any error");
        }
      }, 5000);
    }
  });

  const openModal = (modal) => {
    if (!modal) return;
    document.body.style.overflow = 'hidden';
    modal.setAttribute('open', 'true');
    document.addEventListener('keydown', escClose);
  };

  const setCookie = (name, value, days) => {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + date.toUTCString();
    document.cookie = name + '=' + value + ';' + expires + ';path=/';
  };

  const getCookie = (cname) => {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  };

  const closeModal = (modalToClose, hideForAMonth) => {
    if (!modalToClose) return;
    document.body.style.overflow = 'auto';
    modalToClose.removeAttribute('open');
    document.removeEventListener('keydown', escClose);

    if (hideForAMonth) {
      setCookie('NewsletterModalPref', 'hide', 30);
    } else {
      sessionStorage.setItem('NewsletterModalPref', 'hide');
    }
  };

  const escClose = (e) => {
    if (e.keyCode == 27) {
      const modalToClose = document.getElementById('aw-newsletter-modal');
      if (modalToClose && modalToClose.hasAttribute('open')) {
        closeModal(modalToClose, false);
      }
    }
  };

  // Auto open the modal after timer when whole page is loaded
  window.addEventListener('load', (event) => {
    let getModalPref = sessionStorage.getItem('NewsletterModalPref') || getCookie('NewsletterModalPref') == 'hide' ? true : false;
    let isAdminLoggedIn = $('body').hasClass('hasAdminBar');
    let isLoadedFromIFrame;

    // Is the page loaded from a iframe, for page builder
    if (window.self !== window.top) {
      isLoadedFromIFrame = true;
    } else {
      isLoadedFromIFrame = false;
    }

    if (isAdminLoggedIn) {
      return console.log('Newsletter Modal: Logged in user, Subscription modal disabled!');
    } else if (isLoadedFromIFrame) {
      return console.log('Newsletter Modal: Is loaded from iFrame!');
    } else if (getModalPref) {
      if (sessionStorage.getItem('NewsletterModalPref') == 'hide') {
        console.log('Newsletter Modal: Session level Disabled!');
      } else if (getCookie('NewsletterModalPref') == 'hide') {
        console.log('Newsletter Modal: Subscribed level Disabled!');
      }
      return;
    }

    setTimeout(() => {
      modal = document.getElementById('aw-newsletter-modal');
      openModal(modal);
    }, timer);
  });
}

newsletterModal(true, 3000);

document.addEventListener('DOMContentLoaded', function () {
  const trigger = document.querySelector('.ai-hero-slideshow-subheading-ay25qstbvr1rcutdasaigenblock14110e1rf8ebr');

  if (!trigger) {
    return;
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    const value = match ? decodeURIComponent(match[2]) : null;
    return value;
  }

  trigger.addEventListener('click', function () {
    const pref = getCookie('NewsletterModalPref');
    if (pref === 'hide') {
      console.log('hidden');

      // remove old modal if already exists
      const existing = document.getElementById('aw-already-subscribed-modal');
      if (existing) {
        existing.remove();
      }

      const alreadySubscribedModal = `
        <div id="aw-already-subscribed-modal" class="aw-newsletter-modal" role="dialog" tabindex="-1" open="true" style="position:fixed">
          <div class="aw-newsletter-modal-inner" >
            <div id="aw-already-subscribed-close" class="aw-newsletter-modal-close" title="Close" >
              <span class="svg-wrapper" style="width:45px;margin-left:5px;height:20px">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 17">
                  <path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path>
                </svg>
              </span>
            </div>
            <div class="aw-newsletter-modal-text">
              Already subscribed
            </div>
          </div>
        </div>
      `;

      document.body.insertAdjacentHTML('beforeend', alreadySubscribedModal);
      document.body.style.overflow = 'hidden';

      // close handler
      const closeButton = document.getElementById('aw-already-subscribed-close');
      if (closeButton) {
        closeButton.addEventListener('click', function () {
          const modalToRemove = document.getElementById('aw-already-subscribed-modal');
          if (modalToRemove) {
            modalToRemove.remove();
            document.body.style.overflow = 'auto';
          }
        });
      }

      console.log('[Newsletter Debug] Already subscribed modal shown');
      return;
    }
    
    const modal2 = document.getElementById('aw-newsletter-modal');
    if (!modal2) {
      return;
    }
    
    document.body.style.overflow = 'hidden';
    modal2.setAttribute('open', 'true');
  });
});